<template>
  <ImageBar 
    title="遇见"
    imageUrl="https://picsum.photos/1200/500?random=4"
    height="80px"
  />

  <div class="dating-container">
    <el-alert
      v-if="!friendEnabled && friendStatusLoaded"
      type="warning"
      :closable="false"
      show-icon
      class="friend-feature-alert"
      title="尚未开启朋友功能"
      description="请先在「个人朋友信息」中开启朋友功能并上传至少3张个人照片，才能搜索和查看其他用户。"
    >
      <el-button type="primary" size="small" @click="$router.push('/user/setting')">去开启</el-button>
    </el-alert>

    <div class="search-panel">
      <el-form :model="searchForm" label-width="100px" class="search-form">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="关键词">
              <el-input v-model="searchForm.keyword" placeholder="查找昵称、自我介绍等">
                <template #prefix>
                  <el-icon><Search /></el-icon>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="性别">
              <el-select v-model="searchForm.gender" placeholder="选择性别" clearable>
                <el-option label="男" value="male" />
                <el-option label="女" value="female" />
                
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="年龄范围">
              <el-slider
                v-model="ageRange"
                range
                :min="18"
                :max="80"
                :marks="{
                  18: '18',
                  30: '30',
                  50: '50',
                  70: '70',
                  80: '80'
                }"
                :format-tooltip="value => `${value}岁`"
                class="modern-slider"
                @change="handleAgeRangeChange"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="身高范围">
              <el-slider
                v-model="heightRange"
                range
                :min="150"
                :max="220"
                :marks="{
                  150: '150',
                  170: '170',
                  190: '190',
                  210: '210',
                  220: '220'
                }"
                :format-tooltip="value => `${value}cm`"
                class="modern-slider"
                @change="handleHeightRangeChange"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="体重范围">
              <el-slider
                v-model="weightRange"
                range
                :min="40"
                :max="120"
                :marks="{
                  40: '40',
                  60: '60',
                  80: '80',
                  100: '100',
                  120: '120'
                }"
                :format-tooltip="value => `${value}kg`"
                class="modern-slider"
                @change="handleWeightRangeChange"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="学历">
              <el-select v-model="searchForm.educations" multiple placeholder="选择学历" clearable>
                <el-option label="高中" value="高中" />
                <el-option label="本科" value="本科" />
                <el-option label="硕士" value="硕士" />
                <el-option label="博士" value="博士" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="婚姻状况">
              <el-select v-model="searchForm.maritalStatus" multiple placeholder="选择婚姻状况" clearable>
                <el-option label="未婚" value="未婚" />
                <el-option label="离异" value="离异" />
                <el-option label="丧偶" value="丧偶" />
                <el-option label="再婚" value="再婚" />
                <el-option label="分居" value="分居" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="男孩">
              <el-slider
                v-model="boysRange"
                range
                :min="0"
                :max="10"
                :marks="{
                  0: '0',
                  2: '2',
                  4: '4',
                  6: '6',
                  8: '8',
                  10: '10'
                }"
                :format-tooltip="value => `${value}个`"
                class="modern-slider"
                @change="handleBoysRangeChange"
              />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="女孩">
              <el-slider
                v-model="girlsRange"
                range
                :min="0"
                :max="10"
                :marks="{
                  0: '0',
                  2: '2',
                  4: '4',
                  6: '6',
                  8: '8',
                  10: '10'
                }"
                :format-tooltip="value => `${value}个`"
                class="modern-slider"
                @change="handleGirlsRangeChange"
              />
            </el-form-item>
          </el-col>
           
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="实名认证">
              <el-switch 
                v-model="searchForm.isVerified" 
                :active-value="1" 
                :inactive-value="0"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="测评徽章">
              <el-select
                v-model="searchForm.examBadgeExamId"
                placeholder="选择测评"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="exam in badgeExams"
                  :key="exam.examId"
                  :label="exam.examName"
                  :value="exam.examId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="徽章等级">
              <el-select
                v-model="searchForm.examBadgeTier"
                placeholder="金/银/铜"
                clearable
                :disabled="!searchForm.examBadgeExamId"
                style="width: 100%"
              >
                <el-option label="金徽章" value="gold" />
                <el-option label="银徽章" value="silver" />
                <el-option label="铜徽章" value="bronze" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="兴趣爱好">
              <el-select v-model="searchForm.hobbies" multiple placeholder="选择兴趣爱好" clearable>
                <el-option label="旅游" value="旅游" />
                <el-option label="美食" value="美食" />
                <el-option label="运动" value="运动" />
                <el-option label="音乐" value="音乐" />
                <el-option label="电影" value="电影" />
                <el-option label="阅读" value="阅读" />
                <el-option label="摄影" value="摄影" />
                <el-option label="绘画" value="绘画" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" class="search-buttons">
            <el-button type="primary" @click="handleSearch">遇见</el-button>
            <el-button @click="resetForm">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="dating-grid" v-loading="loading">
      <div v-for="person in peopleList" :key="person.uuid" class="profile-card">
        <div class="profile-photo" @click="viewPerson(person.uuid)">
          <el-image 
            :src="person.photo" 
            fit="cover"
            class="profile-image"
          >
            <template #error>
              <div class="image-placeholder">
                <el-icon><User /></el-icon>
              </div>
            </template>
          </el-image>
          <div class="profile-overlay">
            <div class="profile-basic">
              <h3>{{ person.name }}</h3>
              <div class="age-location">
                <span>{{ person.age }}岁</span>
                <el-divider direction="vertical" />
                <span>{{ person.location }}</span>
              </div>
            </div>
            <div class="profile-tags">
              <el-tag size="small" type="success">{{ person.height }}cm</el-tag>
              <el-tag size="small" type="warning">{{ person.occupation }}</el-tag>
              <el-tag size="small" type="info">{{ person.education }}</el-tag>
              <el-tag v-if="person.boyCount > 0 || person.girlCount > 0" size="small" type="danger">
                {{ getChildrenText(person.boyCount, person.girlCount) }}
              </el-tag>
              <ExamBadgeTag
                v-for="badge in (person.examBadges || []).slice(0, 3)"
                :key="`${badge.examId}-${badge.badgeTier}`"
                :tier="badge.badgeTier"
                :label="badge.badgeLabel"
                :exam-name="badge.examName"
                :score-percent="badge.scorePercent"
              />
            </div>
          </div>
        </div>
        
        <div class="profile-actions">
          <el-button type="primary" text @click="viewPerson(person.uuid)">
            查看详情
          </el-button>
          <el-button type="success" text @click="startChat(person.uuid)">
            聊天
          </el-button>
          <el-button type="danger" text @click="likePerson(person.uuid)">
            <el-icon><Star /></el-icon>
          </el-button>
          <el-button type="danger" text @click="addToBlacklist(person.uuid)">
            <el-icon><CircleClose /></el-icon>
          </el-button>
        </div>
      </div>
    </div>

    <AdminPagination
      v-if="total > 0"
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :page-sizes="[12, 24, 36, 48]"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { Search, User, Star, CircleClose } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import ImageBar from './components/ImageBar.vue'
import AdminPagination from '@/components/AdminPagination.vue'
import ExamBadgeTag from '@/components/exam/ExamBadgeTag.vue'
import { fetchExamBadgeCatalog } from '@/utils/examBadge'
import { resolveProfilePhotoUrl } from '@/utils/photoUpload'
import { markProfileUnlockReminded } from '@/utils/profileUnlock'

export default {
  name: 'SearchView',
  components: {
    Search,
    User,
    Star,
    CircleClose,
    ImageBar,
    AdminPagination,
    ExamBadgeTag
  },
  data() {
    return {
      loading: false,
      friendEnabled: false,
      friendStatusLoaded: false,
      peopleList: [],
      currentPage: 1,
      pageSize: 12,
      total: 0,
      badgeExams: [],
      searchForm: {
        keyword: '',
        gender: '',
        ageMin: 18,
        ageMax: 80,
        heightMin: 150,
        heightMax: 220,
        weightMin: 40,
        weightMax: 120,
        educations: [],
        maritalStatus: [],
        maxBoysMin: 0,
        maxBoysMax: 10,
        maxGirlsMin: 0,
        maxGirlsMax: 10,
        isVerified: 0,
        hobbies: [],
        examBadgeExamId: null,
        examBadgeTier: ''
      },
      ageRange: [18, 80],
      heightRange: [150, 220],
      weightRange: [40, 120],
      searchTimer: null
    }
  },
  created() {
  },
  mounted() {
    this.initializeRanges()
    this.loadBadgeExams()
    this.fetchFriendStatus().then(() => {
      if (this.friendEnabled) {
        this.fetchPeopleList()
      }
    })
  },
  computed: {
    boysRange: {
      get() {
        return [this.searchForm.maxBoysMin, this.searchForm.maxBoysMax]
      },
      set(value) {
        this.searchForm.maxBoysMin = value[0]
        this.searchForm.maxBoysMax = value[1]
      }
    },
    girlsRange: {
      get() {
        return [this.searchForm.maxGirlsMin, this.searchForm.maxGirlsMax]
      },
      set(value) {
        this.searchForm.maxGirlsMin = value[0]
        this.searchForm.maxGirlsMax = value[1]
      }
    }
  },
  methods: {
    getStoredRange(key, defaultValue) {
      const stored = localStorage.getItem(`search_${key}`)
      return stored ? JSON.parse(stored) : defaultValue
    },
    storeRange(key, value) {
      localStorage.setItem(`search_${key}`, JSON.stringify(value))
    },
    getChildrenText(boyCount, girlCount) {
      let text = ''
      if (boyCount > 0) {
        text += `${boyCount}男`
      }
      if (girlCount > 0) {
        text += `${girlCount}女`
      }
      return text
    },
    initializeRanges() {
      const ageRange = this.getStoredRange('ageRange', [18, 80])
      const heightRange = this.getStoredRange('heightRange', [150, 220])
      const weightRange = this.getStoredRange('weightRange', [40, 120])
      const boysRange = this.getStoredRange('boysRange', [1, 10])
      const girlsRange = this.getStoredRange('girlsRange', [1, 10])
      
      this.searchForm.ageMin = ageRange[0]
      this.searchForm.ageMax = ageRange[1]
      this.searchForm.heightMin = heightRange[0]
      this.searchForm.heightMax = heightRange[1]
      this.searchForm.weightMin = weightRange[0]
      this.searchForm.weightMax = weightRange[1]
      this.searchForm.maxBoysMin = boysRange[0]
      this.searchForm.maxBoysMax = boysRange[1]
      this.searchForm.maxGirlsMin = girlsRange[0]
      this.searchForm.maxGirlsMax = girlsRange[1]
    },
    async loadBadgeExams() {
      try {
        this.badgeExams = await fetchExamBadgeCatalog()
      } catch (e) {
        console.error(e)
      }
    },
    async fetchFriendStatus() {
      try {
        const token = localStorage.getItem('jwt_token')
        const uuid = localStorage.getItem('uuid')
        if (!token || !uuid) {
          this.friendStatusLoaded = true
          return
        }
        const response = await fetch('/api/v1/user/myprofile/get', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ uuid })
        })
        const data = await response.json()
        if (data.code === 200 && data.data) {
          this.friendEnabled = !!data.data.friendEnabled
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.friendStatusLoaded = true
      }
    },
    async fetchPeopleList() {
      if (!this.friendEnabled) {
        this.peopleList = []
        this.total = 0
        return
      }
      this.loading = true
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/advsearch', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            keyword: this.searchForm.keyword,
            gender: this.searchForm.gender,
            ageMin: this.searchForm.ageMin,
            ageMax: this.searchForm.ageMax,
            heightMin: this.searchForm.heightMin,
            heightMax: this.searchForm.heightMax,
            weightMin: this.searchForm.weightMin,
            weightMax: this.searchForm.weightMax,
            educations: this.searchForm.educations,
            maritalStatus: this.searchForm.maritalStatus,
            // maxBoysMin: this.searchForm.maxBoysMin,
            maxBoys: this.searchForm.maxBoysMax,
            // maxGirlsMin: this.searchForm.maxGirlsMin,
            maxGirls: this.searchForm.maxGirlsMax,
            hobbies: this.searchForm.hobbies,
            isVerified: this.searchForm.isVerified,
            examBadgeExamId: this.searchForm.examBadgeExamId || undefined,
            examBadgeTier: this.searchForm.examBadgeTier || undefined,
            page: this.currentPage,
            pageSize: this.pageSize
          })
        })

        const data = await response.json()
        if (data.code === 200) {
          this.peopleList = []
          if (data.data && data.data.users) {
            this.peopleList = data.data.users.map(user => ({
              uuid: user.uuid,
              name: user.nickname || '未知',
              age: user.age || 0,
              location: user.city || user.location || '未知',
              height: user.height || 0,
              occupation: user.occupation || '未知',
              education: user.education || '未知',
              photo: resolveProfilePhotoUrl(user.avatar, user.photo) || 'https://example.com/default-avatar.jpg',
              interests: user.hobbies || [],
              description: user.introduction || '',
              sex: user.sex || '',
              weight: user.weight || 0,
              maritalStatus: user.maritalStatus || '',
              isVerified: user.isVerified || 0,
              vipLevel: user.vipLevel || 0,
              boyCount: user.boyCount || 0,
              girlCount: user.girlCount || 0,
              examBadges: user.examBadges || []
            }))
          }
          this.total = data.data.total || 0
        } else {
          ElMessage.error(data.message || '查找用户失败')
        }
      } catch (error) {
        ElMessage.error('查找用户失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      if (!this.friendEnabled) {
        ElMessage.warning('请先在个人朋友信息中开启朋友功能')
        return
      }
      this.currentPage = 1
      this.fetchPeopleList()
    },
    resetForm() {
      this.searchForm = {
        keyword: '',
        gender: '',
        ageMin: 18,
        ageMax: 80,
        heightMin: 150,
        heightMax: 220,
        weightMin: 40,
        weightMax: 120,
        educations: [],
        maritalStatus: [],
        maxBoysMin: 0,
        maxBoysMax: 10,
        maxGirlsMin: 0,
        maxGirlsMax: 10,
      
        isVerified: 0,
        hobbies: [],
        examBadgeExamId: null,
        examBadgeTier: ''
      }
      localStorage.removeItem('search_ageRange')
      localStorage.removeItem('search_heightRange')
      localStorage.removeItem('search_weightRange')
      localStorage.removeItem('search_boysRange')
      localStorage.removeItem('search_girlsRange')
      this.handleSearch()
    },
    viewPerson(uuid) {
      const person = this.peopleList.find(p => p.uuid === uuid)
      if (person && person.photo && person.photo.includes('blur')) {
        ElMessageBox.confirm(
          '你还没访问过该用户，查看需要扣除10分，是否继续查看？',
          '提示',
          {
            confirmButtonText: '继续查看',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(() => {
          markProfileUnlockReminded(uuid)
          this.$router.push(`/profile/${uuid}`)
        }).catch(() => {
          // User cancelled, do nothing
        })
      } else {
        this.$router.push(`/profile/${uuid}`)
      }
    },
    startChat() {
      ElMessage.info('私信功能暂未开放')
    },
    async likePerson(uuid) {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/like', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            targetUuid: uuid,
            likeLevel: 1
          })
        })

        const data = await response.json()
        if (data.code === 200) {
          ElMessage.success('已添加到喜欢列表')
        } else {
          ElMessage.error(data.message || '操作失败')
        }
      } catch (error) {
        ElMessage.error('操作失败')
        console.error(error)
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.fetchPeopleList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.fetchPeopleList()
    },
    handleAgeRangeChange(val) {
      this.searchForm.ageMin = val[0]
      this.searchForm.ageMax = val[1]
      this.storeRange('ageRange', val)
    },
    handleHeightRangeChange(val) {
      this.searchForm.heightMin = val[0]
      this.searchForm.heightMax = val[1]
      this.storeRange('heightRange', val)
    },
    handleWeightRangeChange(val) {
      this.searchForm.weightMin = val[0]
      this.searchForm.weightMax = val[1]
      this.storeRange('weightRange', val)
    },
    handleBoysRangeChange(val) {
      this.searchForm.maxBoysMin = val[0]
      this.searchForm.maxBoysMax = val[1]
      this.storeRange('boysRange', val)
    },
    handleGirlsRangeChange(val) {
      this.searchForm.maxGirlsMin = val[0]
      this.searchForm.maxGirlsMax = val[1]
      this.storeRange('girlsRange', val)
    },
    async addToBlacklist(uuid) {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/blacklist/add', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            targetUuid: uuid
          })
        })

        const data = await response.json()
        if (data.code === 200) {
          ElMessage.success('已添加到黑名单')
          this.fetchPeopleList()
        } else {
          ElMessage.error(data.message || '添加到黑名单失败')
        }
      } catch (error) {
        ElMessage.error('添加到黑名单失败')
        console.error(error)
      }
    }
  }
}
</script>

<style scoped>
.dating-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.friend-feature-alert {
  margin-bottom: 16px;
}

.search-panel {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.search-form {
  margin-bottom: 20px;
}

.separator {
  margin: 0 10px;
}

.search-buttons {
  text-align: center;
  margin-top: 20px;
}

.dating-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
  margin-bottom: 20px;
}

.profile-card {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  transition: all 0.3s;
}

.profile-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.profile-photo {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 125%;
  cursor: pointer;
}

.profile-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s;
}

.profile-image:hover {
  transform: scale(1.05);
}

.profile-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: #fff;
}

.profile-basic h3 {
  margin: 0 0 8px 0;
  font-size: 1.2rem;
  color: #fff;
}

.age-location {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.9);
}

.profile-tags {
  display: flex;
  gap: 8px;
  margin-top: 8px;
  flex-wrap: wrap;
}

.profile-actions {
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
}

.profile-actions .el-button {
  background: rgba(255,255,255,0.85);
  color: #333;
  font-weight: bold;
  border: none;
  box-shadow: 0 2px 8px rgba(0,0,0,0.04);
  transition: background 0.2s, color 0.2s;
}

.profile-actions .el-button:hover {
  background: #fff;
  color: #409EFF;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f7fa;
  color: #909399;
  font-size: 30px;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

/* 现代化滑块样式 */
.modern-slider {
  margin: 20px 0;
}

.modern-slider :deep(.el-slider__runway) {
  height: 4px;
  background-color: #e4e7ed;
}

.modern-slider :deep(.el-slider__bar) {
  height: 4px;
  background-color: var(--el-color-primary);
  border-radius: 2px;
}

.modern-slider :deep(.el-slider__button) {
  width: 16px;
  height: 16px;
  border: 2px solid var(--el-color-primary);
  background-color: #fff;
  transition: all 0.3s;
}

.modern-slider :deep(.el-slider__button:hover) {
  transform: scale(1.2);
}

.modern-slider :deep(.el-slider__marks-text) {
  color: #909399;
  font-size: 12px;
  margin-top: 8px;
}

.modern-slider :deep(.el-slider__marks) {
  top: 20px;
}

.modern-slider :deep(.el-slider__button-wrapper) {
  top: -6px;
}

.modern-slider :deep(.el-tooltip__trigger) {
  outline: none;
}

.modern-slider :deep(.el-slider__marks-stop) {
  width: 2px;
  height: 8px;
  background-color: #dcdfe6;
  border-radius: 1px;
}

.modern-slider :deep(.el-slider__marks-stop.is-active) {
  background-color: var(--el-color-primary);
}

/* 响应式布局优化 */
@media screen and (max-width: 768px) {
  .search-form :deep(.el-form-item__label) {
    float: none;
    display: block;
    text-align: left;
    padding: 0 0 8px;
  }

  .search-form :deep(.el-form-item__content) {
    margin-left: 0 !important;
  }

  .modern-slider {
    margin: 30px 0;
  }

  .modern-slider :deep(.el-slider__marks) {
    top: 30px;
  }

  .modern-slider :deep(.el-slider__marks-text) {
    font-size: 11px;
  }
}

@media screen and (max-width: 576px) {
  .dating-container {
    padding: 0;
  }

  .search-panel {
    padding: 8px;
  }

  .el-row {
    margin-bottom: 0 !important;
  }

  .el-col {
    margin-bottom: 15px;
  }
}
</style> 